module.exports = __webpack_public_path__ + "media/sound-alarm.4a4fd922.mp3";